/*
 * @Author: yusha
 * @Date: 2023-07-20 10:49:32
 * @LastEditors: yusha
 * @LastEditTime: 2023-07-20 11:10:28
 * @Description:
 */
import { post, get, getFrom, post_query, post_OSS, post_blob } from "@/axios";
/**
 * 入库 -----------------------------------------------------------------------------------------
 * **/

/**
 * 签收查询
 * **/
export const signQuery = function (params) {
  return get("/wms/sign/queryByExpressNoOrInboundCode", params);
};
/**
 * 签收批量提交
 * **/
export const signSubmit = function (params) {
  return post("/wms/sign/saveSignRecords", params);
};

/**
 * 入库查询
 * **/
export const inHouseQuery = function (params) {
  return get("/wms/stockIn/queryPurchaseInfo", params);
};

/**
 * 入库查询 _new
 * **/
export const queryWithInboundCode = function (params) {
  return get("/wms/stockIn/queryWithInboundCode", params);
};

/**
 * 入库查询2
 */
export const inHouseQuery2 = function (params) {
  return get("/wms/stockIn/queryPurchaseInfo", params);
};

/**
 * 提交入库
 * **/
export const inHouseDoStockIn = function (params) {
  return post("/wms/stockIn/doStockInWithInboundCode", params);
};

/**
 * 提交入库_new
 * **/
export const doStockInWithInboundCode = function (params) {
  return post("/wms/stockIn/doStockInWithInboundCode", params);
};

/**
 * 获取单个批次包信息
 * **/
export const getPkgInfoSingle = function (params) {
  return get("/wms/transfer/queryPkg4Transfer", params);
};

/**
 * 获取单个批次包信息
 * **/
export const queryPkgTransferList = function (params) {
  return get("wms/transfer/queryPkg4TransferList", params);
};

/**
 * 通过当个批次包 获取 整个移库单信息（多个批次包）
 * **/
export const getPkgInfoMonde = function (params) {
  return get("/wms/transfer/getTransfer", params);
};

/**
 * 生成移库单（多个批次包）
 * **/
export const createTransferMonde = function (params) {
  return post("/wms/transfer/doTransfer", params);
};

/**
 * 调拨单 确认/驳回（多个批次包）
 * **/
export const transferMondeConfirm = function (params) {
  return post("/wms/transfer/doConfirm", params);
};

/**
 * 移库批次包拆包
 * **/
export const transferPkgSpilt = function (params) {
  return post("/wms/transfer/pkg/spilt", params);
};

/**
 * 移库批次包拆包
 * **/
export const transferGetTransferSpiltPkgs = function (params) {
  return get("/wms/transfer/getTransferSpiltPkgs", params);
};

/**
 * 获取pkg打印模板
 * **/
export const getPkgTemplate = function (params) {
  return get("/wms/print/getPkgTemplate", params);
};
/**
 * 根据模板编号查询模板
 * **/
export const printQueryByCode = function (params) {
  return get("/wms/print/queryByCode", params);
};
/**
 * 根据ID查询模板
 * **/
export const printQueryById = function (params) {
  return get("/wms/print/queryById", params);
};

//创建包裹异常流程
export const createSignFlow = function (params) {
  return post("/wms/flow/createSignFlow", params);
};

//申请图片上传码
export const getApplyCode = function (params) {
  return get("/wms/img/applyCode", params);
};

//查询图片
export const imgByCode = function (params) {
  return get("/wms/img/queryByCode", params);
};

// 查询扫码上传图片，不走旧 queryByCode 仓库过滤
export const imgByQr = function (params) {
  return get("/wms/img/queryImagesByQr", params);
};

// 后台/H5 共用扫码上传保存接口
export const imgSaveByQr = function (params) {
  return post("/wms/img/uploadImagesByQr", params);
};

// 删除扫码上传图片
export const deleteImageByQrApi = function (params) {
  return get("/wms/img/deleteByQr", params);
};

export const OSSsign = function (params) {
  return post_query("/customer/oss/sign", params);
};

export const imageToOss = function (url, params) {
  return post_OSS(url, params);
};

export const imgSave = function (params) {
  return post("/wms/img/saveImg", params);
};
//获取订单下的附加项
export const getOrderAdditionApi = function (params) {
  return get(
    "/order/customer/platformOrderItem/getAdditionalItemsInfo",
    params
  );
};
//图片删除
export const deleteImageApi = function (params) {
  return get("/wms/img/delete", params);
};

//入库单
export const inboundOrderPage = function (params) {
  return post("/wms/inboundOrder/page", params);
};

//入库单 子表格
export const inboundSkuInfo = function (params) {
  return get("/wms/inboundOrder/skuInfo", params);
};

// 入库单操作详情
export const operateRecord = function (params) {
  return post("/wms/inboundOrder/pageOperationRecord", params);
};
//入库单 创建
export const createManualInboundOrder = function (params) {
  return post_OSS("/wms/inboundOrder/createManualInboundOrder", params);
};

//入库单 关闭
export const closeInboundOrder = function (params) {
  return post("/wms/inboundOrder/close", params);
};

//入库单 购买数量
export const purchaseNumInfo = function (params) {
  return get("/wms/inboundOrder/purchaseNumInfo", params);
};

//
export const getCustomerByID = function (params) {
  return post("/customer/shop/get", params);
};
//入库单-入库数量详情
export const inboundNumInfo = function (params) {
  return get("/wms/inboundOrder/inboundNumInfo", params);
};

//入库单-状态数量统计
export const getTotalNum = function (params) {
  return get("/wms/inboundOrder/countByType", params);
};

//入库单-获取商品信息
export const detailSpiderByUrl = function (params) {
  return post("/goods/product/detailSpiderByUrl", params);
};


// sku查 spu
export const byProductSku = function (params) {
  return get("/goods/product/detail/backend/byProductSku", params);
};


//入库单-更新商品规格
export const updateProp = function (params) {
  return post("/wms/inboundOrder/updateProp", params);
};

//入库单-更新按钮
export const updateByUrl = function (params) {
  return post("/wms/inboundOrder/updateByUrl", params);
};

//url 搜索商品
export const goodsDetailAndSaveByUrlApi = function (params) {
  return post("/goods/product/detailSpiderByUrlWithoutToken", params);
};

//手动入库--修改商品规格
export const updatePropApi = function (params) {
  return post("/wms/inboundOrder/updateProp", params);
};

//手动入库-获取一键入库详情
export const getOneKeyInfoListApi = function (params) {
  return get("/wms/inboundOrder/oneKey/info", params);
};
//手动入库--取消入库
export const cancelSku = function (params) {
  return post("/wms/inboundOrder/cancelSku", params);
};

//手动入库--一键入库
export const inboundOrderConfirmApi = function (params) {
  return post("/wms/inboundOrder/oneKey/confirm", params);
};

//手动入库--完成入库
export const finishOrderCompleteApi = function (params) {
  return post("/wms/inboundOrder/oneKey/complete", params);
};

export const getSignNewApi = ({ bucketName, path, type }) => {
  return post(
    `/customer/oss/sign/another?bucketName=${bucketName}&path=${path}&type=${type}`
  );
};
export const updateImgs = (params) => {
  return post(`/wms/flow/updateImgs`, params);
};
//通知采购
export const updatePurchaseImgs = (params) => {
  return post(`/wms/flow/updatePurchaseImgs`, params);
};

//包裹信息
export const queryLogisticsInfo = (params) => {
  return get(`/wms/stockIn/queryLogisticsInfo`, params);
};
//入库操作日志
export const operateLog = (params) => {
  return post(`/wms/operate/record/page`, params);
};

//手动入库--获取sku信息
export const getInfoBySku = (params) => {
  return get(`/wms/inboundOrder/getInfoBySku`, params);
};

//手动入库--修改商品规格bySKU
export const updatePropBySku = (params) => {
  return post(`/wms/inboundOrder/updatePropBySku`, params);
};

//简单检品界面【入库,异常给采购,异常给用户】--新入库单版本
export const newDoStockInWithInboundCode = function (params) {
  return post(`/wms/stockIn/doStockInWithInboundCode`, params)
}

// 简单检品查询采购信息--改版简单检品查询
export const newQueryWithInboundCode = function (params) {
  return get('/wms/stockIn/new/queryWithInboundCode', params)
}

/**
 * 少件到货提交入库
 * **/
export const shortageArrival = function (params) {
  return post("/wms/stockIn/shortageArrival", params);
};

// 查询特殊入库要求
export const querySpecialInboundRequirement = function (params) {
  return get('/wms/stockIn/querySpecialInboundRequirement', params)
}





/**
 * 查询后台用户
 * **/
export const searchManageUserApi = function (params) {
  return get("/customer/users/getUserByMobile", params);
};

/**
 * 新品测量分类配置
 * **/
export const getCategoryConfigListApi = function (params) {
  return get("/wms/measure/get/category/config", params);
};

/**
 * 批量提交新品测量结果
 * **/
export const batchEditSizeApi = function (params) {
  return post("/wms/measure/batch/editSize", params);
};

export const checkSpecialInboundRequirementCustomer = function (params) {
  return get("/wms/inboundOrder/checkSpecialInboundRequirementCustomer", params);
};

/**
 * 供应商模糊搜索
 * **/
export const getSupplierShopNameListApi = function (params) {
  return post("/goods/supplierShop/pageList", params);
};

export const getQueryWithSupplierApi = function (params) {
  return post("/wms/stockIn/new/queryWithSupplier", params);
};

/**
 * 入库异常登记分页
 */
export const inboundExceptionPage = function (params) {
  return post("/wms/inboundException/page", params);
};

/**
 * 查询 Nacos 配置的需回复人
 */
export const inboundExceptionReplyUsers = function () {
  return get("/wms/inboundException/replyUsers");
};

/**
 * 新增入库异常
 */
export const inboundExceptionSave = function (params) {
  return post("/wms/inboundException/save", params);
};

/**
 * 编辑未回复入库异常
 */
export const inboundExceptionEdit = function (params) {
  return post("/wms/inboundException/edit", params);
};

/**
 * 删除未回复入库异常
 */
export const inboundExceptionDelete = function (params) {
  return post("/wms/inboundException/delete", params);
};

/**
 * 提交采购回复
 */
export const inboundExceptionReply = function (params) {
  return post("/wms/inboundException/reply", params);
};

/**
 * 查询入库异常操作日志
 */
export const inboundExceptionLogs = function (params) {
  return get("/wms/inboundException/logs", params);
};

/**
 * 导出入库异常 Excel
 */
export const inboundExceptionExport = function (params) {
  return post_blob("/wms/inboundException/export", params);
};

export const queryPurchaseTwoLevelTagApi = function (params) {
  return post("/purchase/purchase/queryPurchaseTwoLevelTag", params);
};

